import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=c4a529de&"
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4a529de')) {
      api.createRecord('c4a529de', component.options)
    } else {
      api.reload('c4a529de', component.options)
    }
    module.hot.accept("./Question.vue?vue&type=template&id=c4a529de&", function () {
      api.rerender('c4a529de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/UcidAnalysis/Question.vue"
export default component.exports